const state = {
  userData: null,
}

const mutations = {
  SET_USER_DATA (state, userData) {
    state.userData = userData
  },

  CLEAR_USER_DATA (state) {
    state.userData = null
  },
}

const actions = {
  setUserData (context, payload) {
    context.commit('SET_USER_DATA', payload)
  },
  clearUserData (context) {
    context.commit('CLEAR_USER_DATA')
  },
}

const getters = {
  isAdmin (state) {
    return state.userData && state.userData.role === 'admin'
  },

  userRole (state) {
    return state.userData ? state.userData.role : ''
  },

  isAuthenticated (state) {
    return !!state.userData
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
